module.exports = __webpack_public_path__ + "static/media/visa.5bc8a4f4.png";